module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "dialog-general-note",
    attrs: {
      "visible": _vm.visible,
      "before-close": _vm.exit,
      "show-close": false
    }
  }, [_c('h3', {
    staticClass: "ui header",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.is_new ? '创建备忘录' : '编辑备忘录'))])]), _c('el-form', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("内容")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.note),
      expression: "form.note"
    }],
    domProps: {
      "value": (_vm.form.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "note", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("标签")]), _c('el-select', {
    attrs: {
      "multiple": "multiple",
      "filterable": "filterable",
      "allow-create": "allow-create",
      "placeholder": "选择标签..."
    },
    model: {
      value: (_vm.form.tags),
      callback: function($$v) {
        _vm.$set(_vm.form, "tags", $$v)
      },
      expression: "form.tags"
    }
  }, _vm._l((_vm.tags_candidates), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _c('div', {
    staticClass: "ui four fields"
  }, [_c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("创建人")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form._creator),
      expression: "form._creator"
    }],
    attrs: {
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.form._creator)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "_creator", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("创建时间")]), _c('input', {
    attrs: {
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.$formatters.date.to_datetime(_vm.form.time_created)
    }
  })]), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("最后编辑")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form._modifier),
      expression: "form._modifier"
    }],
    attrs: {
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.form._modifier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "_modifier", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "ui field"
  }, [_c('label', [_vm._v("编辑时间")]), _c('input', {
    attrs: {
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.$formatters.date.to_datetime(_vm.form.time_modified)
    }
  })])]), _c('div', {
    staticClass: "ui field"
  }, [_c('labeL', [_vm._v("状态")]), _c('el-checkbox', {
    model: {
      value: (_vm.form.state),
      callback: function($$v) {
        _vm.$set(_vm.form, "state", $$v)
      },
      expression: "form.state"
    }
  }, [(_vm.form.state) ? _c('span', [_vm._v("已处理"), _c('el-tooltip', {
    attrs: {
      "content": "已处理的项目会在未修改三天后自动消失",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "icon help circle semitrans"
  })])], 1) : _c('span', [_vm._v("未处理")])]), _c('el-checkbox', {
    model: {
      value: (_vm.form.pinned),
      callback: function($$v) {
        _vm.$set(_vm.form, "pinned", $$v)
      },
      expression: "form.pinned"
    }
  }, [_vm._v("置顶")]), _c('el-checkbox', {
    model: {
      value: (_vm.form.collapsable),
      callback: function($$v) {
        _vm.$set(_vm.form, "collapsable", $$v)
      },
      expression: "form.collapsable"
    }
  }, [_c('span', [_vm._v("允许折叠")]), _c('el-tooltip', {
    attrs: {
      "content": "（暂不可用）允许系统在需要时以\"...\"的形式折叠过长的文本内容",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "icon help circle semitrans"
  })])], 1)], 1)]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "ui button themed",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]), _c('div', {
    staticClass: "ui button",
    on: {
      "click": _vm.exit
    }
  }, [_vm._v("取消")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c590f040","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/forms/DialogGeneralNote.vue
// module id = 373
// module chunks = 0